import { useState, useContext, useEffect } from "react"
import { CMultiSelect, CToggle, ReportSelectPeriod, TablePage, toast, CSelect, CSkeletonTable, ModalDelete, TablePagination, CModal, ModalFilterUser } from "../../components/widget"
import { ContextNav, ContextAbsence, ContextLoading, ContextDashboard } from "../../context";
import { VcationReasonsApi, DeleteVcationReasonsApi, TicketApi } from "../../api";
import { DatePicker } from "jalali-react-datepicker";
import { convertDateToString, converDurationToMin } from "../../utils";
import { Link } from 'react-router-dom'

export const Ticket = () => {
    const CtxNav = useContext(ContextNav)
    const CtxLoad = useContext(ContextLoading)
    const CtxDash = useContext(ContextDashboard)
    const [tableData, setTableData] = useState<any>([])
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(0);
    const [jsonParms, setJsonParms] = useState({ 'page': 1 })

    const changePage = (type: string) => {
        let data = { ...jsonParms };
        if (type == 'next') {
            data['page'] = currentPage + 1;
        }
        else {
            data['page'] = currentPage - 1;
        }
        setJsonParms(data)
        getData(data)
    }


    const getData = async (params: any) => {
        try {
            CtxLoad.setDisplayLoadingBlur(true)
            let res = await TicketApi(params)
            setTableData(res.data.data)
            CtxLoad.setDisplayLoadingBlur(false)
            setCurrentPage(res.data.current_page)
            setLastPage(res.data.last_page)
        }
        catch (err: any) {
            CtxLoad.setDisplayLoadingBlur(false)
        }
    }

    useEffect(() => {
        document.title = "تیکت ها | دایان"
        CtxNav.setActiveMenuItem({ 'item': -1, 'subItem': 0, })
        getData(jsonParms)

    }, [])

    return (
        <div className=" w-full flex flex-col">
            <h1 className="sm:text-2xl text-lg font-bold mb-[30px]">تیکت‌ها</h1>


            <div className=" w-full flex md:flex-row flex-col items-center justify-between  mt-[7px] md:mt-[25px]">
                <div></div>
                <div className=" w-full md:w-fit flex items-center md:mt-0 mt-[7px]">
                    <button className=" w-full md:w-[150px] h-[30px] md:h-[40px] bg-dayan-gray-200 rounded-md md:text-sm text-[11px] text-white">
                        <Link to='/p/ticket/add' className=" w-full h-full flex justify-center items-center">
                            + ایجاد تیکت جدید
                        </Link>
                    </button>
                </div>
            </div>

            <div className=" w-full my-[20px] shadow px-3 flex items-center text-sm h-[50px] rounded-lg">
                <img src="/assetes/svg/info.svg" className=" w-[20px] ml-2" />
                <span>پاسخ تیکت شما، به ایمیلتان ارسال می‌شود.</span>
            </div>

            <div className=" w-full flex flex-col">
                {tableData.map((item: any, index: number) =>
                    <div className=" w-full p-5 bg-white shadow rounded-lg mb-2 flex flex-col">
                        <h3>{item.subject}</h3>
                        <span className="text-[11px] mt-1">{new Date(item.created_at	).toLocaleDateString('fa-Ir')}</span>
                        <span className="mt-2 text-[11px] text-justify leading-6">{item.body}</span>
                    </div>
                )}
            </div>

            <div className=" w-full mt-[20px]">
                <TablePagination currentPage={currentPage} lastPage={lastPage} onChange={changePage} />
            </div>


        </div>
    )
}
